import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getVoucher = async (data, token) => {
  return await callPost(REQ.BULK_SALE.GET_VOUCHER, data, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.BULK_SALE.SAVE_DATA, data, token);
};

export const getData = async (id, token) => {
  return await callGet(`${REQ.BULK_SALE.GET_DATA}/${id}`, token);
};

export const updateBulkSale = async (data, token) => {
  return await callPut(
    `${REQ.BULK_SALE.UPDATE_BULK_SALE}/${data.id}`,
    data,
    token
  );
};

export const deleteSingleBulkSale = async (id, token) => {
  return await callDelete(
    `${REQ.BULK_SALE.DELETE_SINGLE_BULK_SALE}/${id}`,
    {},
    token
  );
};

export const deleteBulkSale = async (id, token) => {
  return await callDelete(`${REQ.BULK_SALE.DELETE_BULK_SALE}/${id}`, {}, token);
};
